import { define } from "remount";
import { LocationMapSearch } from "../../src/LocationMapSearch/LocationMapSearch";
import { EventsCarousel } from "../../src/shared/EventsCarousel";
import { withGoogleScriptsLibraries } from "../../src/withGoogleScriptsLibraries";

const googleScriptsLibraries = ["places" as const];

document.addEventListener("DOMContentLoaded", () => {
  define({
    "events-carousel": EventsCarousel,
    "location-map-search": withGoogleScriptsLibraries(LocationMapSearch),
  });
});
